import Vue from 'vue'
import { RouteGroup } from '@billow/easy-route'
import Router from 'vue-router'
import { concat, omitBy } from 'lodash'
import { parse, stringify } from 'qs'
import guest from '@/router/routes/guest'
import auth from '@/router/routes/auth'
import labels from '@/router/routes/label'
import customerProjects from '@/router/routes/project'
import customerUsers from '@/router/routes/user'
import connection from '@/router/routes/connection'
import asset from '@/router/routes/asset'
import security from '@/router/routes/security'
import company from '@/router/routes/company'
import notes from '@/router/routes/notes'
import setup from '@/router/routes/setup'
import subscription from '@/router/routes/subscription'

Vue.use(Router)

let appRoutes = RouteGroup({

  middleware: ['company-is-setup', 'user-is-setup','auth', 'password-set'],

  routes: concat(
    auth,
    customerProjects,
    customerUsers,
    labels,
    connection,
    asset,
    company,
    notes,
    subscription
  )
})

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  parseQuery: query => {
    return parse(query)
  },
  stringifyQuery: query => {
    let queryString = stringify(omitBy(query, value => {
      return value === '' || value === null
    }), {
      arrayFormat: 'brackets'
    })
    return (queryString) ? `?${queryString}` : ''
  },
  routes: concat(
    guest,
    setup,
    security,
    appRoutes
  )
})
